export default __webpack_public_path__ + "static/media/Icons_16.e36d2847.svg";